document.querySelectorAll('[data-category-tabs]').forEach((root) => {
  const tabs = [...root.querySelectorAll('[data-category-tab]')];
  const panels = [...root.querySelectorAll('[data-category-panel]')];
  tabs.forEach((tab, index) => tab.addEventListener('click', () => {
    const panelId = tab.getAttribute('aria-controls');
    tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
    panels.forEach((panel) => { panel.hidden = panel.id !== panelId; });
    tabs[index]?.focus();
  }));
});
